module.exports = __webpack_public_path__ + "202408221624/img/animation_baoquan.cf6374fb.png";